import { LocationOn, Phone } from '@mui/icons-material'
import {
  Avatar,
  Box,
  CardMedia,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Stack,
  Typography
} from '@mui/material'
import React, { FC, useContext } from 'react'

import { RepairOrderPortalContext } from '../../providers/RepairOrderPortalProvider/RepairOrderPortalProvider'
import { ShopEntry } from '../../sdk'

interface Props {
  shop: ShopEntry
}

const ShopContactBox: FC<Props> = ({ shop }) => {
  const { technician, serviceAdvisor } = useContext(RepairOrderPortalContext)

  return (
    <Paper
      variant="outlined"
      component={Stack}
      p={2}
      spacing={1}
      sx={{ width: '100%', boxSizing: 'border-box' }}>
      <Typography variant="h2">Contact Us</Typography>
      <Stack spacing={1} direction="row">
        <Box sx={{ maxWidth: '24px' }}>
          <CardMedia component="img" image={shop.info?.shopLogoUrl} />
        </Box>
        <Typography variant="h6">{shop.info?.name}</Typography>
      </Stack>
      <Stack spacing={1} direction="row">
        <Phone />
        <Link href={'tel:' + shop.info!.phone}>{shop.info!.phone}</Link>
      </Stack>
      <Stack spacing={1} direction="row">
        <LocationOn />
        <Link href={'http://maps.google.com/?q=' + shop.info!.address}>
          {shop.info!.address}
        </Link>
      </Stack>
      <List disablePadding>
        {technician?.map((tech) => (
          <ListItem key={tech.id} disablePadding>
            <ListItemAvatar>
              <Avatar alt={tech.name} src={tech.profilePicUrl} />
            </ListItemAvatar>
            <ListItemText primary={tech.name} secondary="Technician" />
          </ListItem>
        ))}
        {serviceAdvisor?.map((advisor) => (
          <ListItem key={advisor.id} disablePadding>
            <ListItemAvatar>
              <Avatar alt={advisor.name} src={advisor.profilePicUrl} />
            </ListItemAvatar>
            <ListItemText primary={advisor.name} secondary="Service Advisor" />
          </ListItem>
        ))}
      </List>
    </Paper>
  )
}

export default ShopContactBox
